'use strict';
import jwt_decode from 'jwt-decode';

import { LocalStorageHandler, LocalStorageKeys } from '../../core/local-storage-handler';
import { isDefined } from '../../utils/variables';

interface IntercomSignaturePayload {
  identifier: string;
  name: string;
  email?: string;
}

interface AuthPayload {
  userId: string;
  userEmail: string;
  isOrganizationAdmin: boolean;
  intercomSignature?: IntercomSignaturePayload;
}
/**
 *  The Token service that leverages the authentication token to asan AngularJs service.
 */
/* @ngInject */
export class TokenService {
  set(token: string) {
    LocalStorageHandler.instance.setValue(LocalStorageKeys.Token, token);
  }

  get(): string {
    return LocalStorageHandler.instance.getValue(LocalStorageKeys.Token)!;
  }

  remove() {
    LocalStorageHandler.instance.removeKey(LocalStorageKeys.Token);
  }

  decodeToken(token: string): any {
    return jwt_decode(token);
  }

  getIntercomSignature() {
    const token = this.get();
    if (!isDefined(token)) {
      return undefined;
    }

    return (this.decodeToken(token) as AuthPayload).intercomSignature;
  }
}
